const statusOptions = [
  { key: 'Cleared', value: 'Cleared' },
  { key: 'Settled', value: 'Settled' },
];

export {
  statusOptions,
};
